/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userPinResetRequest

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userPinResetRequest.UserPinResetRequestApi
import features.userPinResetRequest.models.UserPinResetRequest
import features.userPinResetRequest.serializeUserPinResetRequestState



/**
 * Request a PIN reset. Either a phone number or email address is required If successful, a verification code will be sent by either email or SMS message.  [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserPinResetRequestApi")
class UserPinResetRequestApiJs {

    /**
     * Request a PIN reset. Either a phone number or email address is required If successful, a verification code will be sent by either email or SMS message. 
     */
    fun requestPinReset(
        overrideHeaders: String?, 
        mode: String = "verification_code",
        email: String? = null,
        phone: String? = null,
        countryCode: String? = null
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = UserPinResetRequestApi().requestPinReset(
            overrideHeaders = decodedOverrideHeaders,
                        mode = mode,
            email = email,
            phone = phone,
            countryCode = countryCode
        ).toJsonResult<UserPinResetRequest>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeUserPinResetRequestState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserPinResetRequestApi().userPinResetRequestState.serializeUserPinResetRequestState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
